import { ArrowRight, GraduationCap, Handshake, Infinity as InfinityIcon } from "lucide-react";
import { Reveal, scrollToId } from "@/components/Reveal";

const PERKS = [
  {
    icon: GraduationCap,
    title: "Licensing Path & Mentorship",
    body: "Train directly with a licensed strategist and earn your own credentials with guided support.",
  },
  {
    icon: Handshake,
    title: "Backed by GFI",
    body: "Build your book of business on the Global Financial Impact platform with proven systems.",
  },
  {
    icon: InfinityIcon,
    title: "Uncapped, Flexible Growth",
    body: "Set your own schedule and scale your income in step with the impact you create.",
  },
];

export const JoinTeam = () => (
  <section id="join-team" data-testid="join-team-section" className="relative overflow-hidden bg-obsidian py-28 lg:py-40">
    <div
      className="absolute right-0 top-10 h-[28rem] w-[28rem] rounded-full bg-gold/5 blur-[150px]"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:gap-24">
        <div>
          <Reveal>
            <p className="eyebrow mb-6" data-testid="join-team-eyebrow">Join the Team</p>
            <h2 className="font-display text-2xl font-semibold tracking-tight text-white sm:text-3xl lg:text-4xl">
              Build your own legacy
              <span className="text-gold-gradient"> by building others’.</span>
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-white/55" data-testid="join-team-copy">
              Vision Aries Financial Impact is growing. Whether you are licensed or brand new to
              financial services, you can build a purpose-driven business helping families protect,
              grow, and transfer wealth.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href="mailto:robertaraehare.gfi@gmail.com?subject=Joining%20the%20Vision%20Aries%20Team"
                data-testid="join-team-apply-button"
                className="group flex items-center gap-3 bg-gold px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] text-obsidian transition-all duration-300 hover:bg-gold-light hover:shadow-[0_0_40px_rgba(212,175,55,0.35)]"
              >
                Start the Conversation
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
              </a>
              <button
                onClick={() => scrollToId("#contact")}
                data-testid="join-team-info-button"
                className="border border-white/20 px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] text-white/80 transition-all duration-300 hover:border-gold/60 hover:text-gold"
              >
                Request Team Info
              </button>
            </div>
          </Reveal>
        </div>

        <div className="space-y-4">
          {PERKS.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.title} delay={i * 0.08}>
                <div
                  className="gold-border-glow group flex items-start gap-6 bg-wine/70 p-7"
                  data-testid={`join-perk-${i + 1}`}
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-gold/30 bg-royal/60 text-gold transition-colors duration-500 group-hover:bg-gold group-hover:text-obsidian">
                    <Icon size={18} strokeWidth={1.5} />
                  </span>
                  <span>
                    <span className="block font-display text-lg font-medium text-white">{p.title}</span>
                    <span className="mt-2 block text-sm leading-relaxed text-white/50">{p.body}</span>
                  </span>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
